module.exports = __webpack_public_path__ + "static/media/tastingnotes_pin.eab445b1.png";